import React from 'react'
import styled from 'styled-components'
import { Icon } from 'app/assets/icons'
import type { FilterShortDTO } from 'shared/types'
import { TooltipPop } from 'app/common/tooltip-pop'
import { SmallText } from '../common/typography'

type Props = {
    allergens: Array<FilterShortDTO>
}

const AllergensWrapper = (props: Props) => {
    const { allergens } = props
    return (
        <AllergenContainer>
            {allergens.map((allergen: FilterShortDTO, index) => {
                return (
                    <TooltipPop key={index} label={allergen.name}>
                        <AllergenIcon>
                            {allergen.code ? (
                                <Icon code={allergen.code} />
                            ) : (
                                <SmallText>{allergen.name}</SmallText>
                            )}
                        </AllergenIcon>
                    </TooltipPop>
                )
            })}
        </AllergenContainer>
    )
}

const AllergenContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding-top: 10px;
`

const AllergenIcon = styled.div`
    padding: 5px;
`

export { AllergensWrapper }
